<template>
  <div class="certifications-section section">
    <h2 class="section-title">
      <span class="icon"><i class="mdi mdi-certificate"></i></span>
      Certifications
    </h2>
    <div class="certification-list">
      <div
        v-for="(certification, index) in certifications"
        :key="`cert-${index}`"
        class="certification-item"
      >
        <div class="certification-header">
          <span class="certification-name">{{ certification }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CertificationsSection',
  props: {
    certifications: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 1.5rem 2rem;
  margin-bottom: 2rem;
}

.section-title {
  display: flex;
  align-items: center;
  color: $color-text;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid $color-border-muted;

  .icon {
    margin-right: 12px;
    color: $color-primary;
  }
}

.certification-list {
  display: flex;
  flex-direction: column;
  gap: 12px;

  .certification-item {
    padding: 12px 16px;
    background-color: rgba(239, 191, 65, 0.3);
    border-left: 3px solid $color-primary;
    border-radius: 4px;
    transition: all 0.2s ease;

    &:hover {
      transform: translateX(2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .certification-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .certification-name {
        font-weight: 600;
        color: $color-text;
        font-size: 1rem;
      }
    }
  }
}
</style>